export * from "./PopupMessageActionButtonConfiguration";
//# sourceMappingURL=index.js.map